import { CalendarRange, X } from "lucide-react";

export function PeriodFilter({ start, end, setStart, setEnd, testPrefix = "period", label = "Período" }) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-800 bg-slate-900 p-3" data-testid={`${testPrefix}-filter`}>
      <div className="flex items-center gap-1.5 text-slate-300">
        <CalendarRange className="h-4 w-4 text-orange-400" />
        <span className="text-sm font-medium">{label}</span>
      </div>
      <input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid={`${testPrefix}-start`}
        className="rounded-lg border border-slate-700 bg-slate-950 px-3 py-1.5 text-sm text-slate-100" />
      <span className="text-sm text-slate-500">até</span>
      <input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid={`${testPrefix}-end`}
        className="rounded-lg border border-slate-700 bg-slate-950 px-3 py-1.5 text-sm text-slate-100" />
      {(start || end) && (
        <button onClick={() => { setStart(""); setEnd(""); }} data-testid={`${testPrefix}-clear`}
          className="flex items-center gap-1 rounded-lg border border-slate-700 px-2.5 py-1.5 text-sm text-slate-400 hover:border-rose-500/40 hover:text-rose-300">
          <X className="h-3.5 w-3.5" /> Limpar
        </button>
      )}
    </div>
  );
}
